import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import FiltrosReporteHistoriaEntity from 'src/app/classes/FiltrosReporteHistoriaEntity';

@Component({
  selector: 'app-reporte-evolucion-filtros',
  templateUrl: './filtros.component.html',
  styleUrls: ['./filtros.component.css']
})
export class FiltrosComponent implements OnInit {

  @Input() filtros: FiltrosReporteHistoriaEntity;

  @Output() generar: EventEmitter<any>;
  @Output() imprimir: EventEmitter<any>;

  constructor() {
    this.generar = new EventEmitter();
    this.imprimir = new EventEmitter();
  }

  ngOnInit() {
  }

  onGenerar() {
    this.generar.emit();
  }

  onImprimir() {
    this.imprimir.emit();
  }

  onDiligenciados(value: boolean) {
    this.filtros.diligenciados = value;
  }

  onSolicitud(value: boolean) {
    this.filtros.solicitudServicios = value;
  }

  onFirmaProfesional(value: boolean) {
    this.filtros.firmaProfesional = value;
  }

  onFirmaAfiliado(value: boolean) {
    this.filtros.firmaAfiliado = value;
  }

  onNotas(value: boolean) {
    this.filtros.notas = value;
  }

  // Auxiliares
  
  isHTML(): boolean {
    return !this.filtros.isPDF();
  }

  isEnabledGenerar(): boolean {
    return this.filtros.permisos > 0;
  }

  isEnableImprimir(): boolean {
    return this.filtros.permisos == 2;
  }

}
